export default __webpack_public_path__ + "static/media/element_47.4461f3db.webp";